import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { BrowserRouter } from "react-router-dom";
import Router from "./routes/router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DarkModeProvider } from "./context/darkModeProvider.context";

function App() {
  return (
    <DarkModeProvider>
      <BrowserRouter>
        <Router />
        <ToastContainer position="top-center" autoClose={3000} />
      </BrowserRouter>
    </DarkModeProvider>
  );
}

export default App;
